import type { LucideProps } from 'lucide-react';
import { AlertTriangle } from 'lucide-react';

export default function WarningIcon(props: LucideProps) {
  return <AlertTriangle {...props} />;
}
